import { UEUpload } from "@/api/common";

export default {
  data() {
    return {
      editorConfig: {
        UEDITOR_HOME_URL: "/UEditor/",
        serverUrl: UEUpload,
      },
      editorDependencies: ["ueditor.config.js", "ueditor.all.js"],
    };
  },
};
